import { CSSProperties, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

interface IDimmedBackgroundProps {
  // display의 제어권이 isShow props를 전달한 컴포넌트에 있음
  isShow: boolean;
  children?: React.ReactNode;
  style?: CSSProperties;

  // display의 제어권이 DimmedBackground 컴포넌트에 있음
  onClick?: () => void;
}

export const DimmedBackground = ({
  isShow,
  children,
  style,
  onClick,
}: IDimmedBackgroundProps) => {
  const ref = useRef<Element | null>(null);
  const [mounted, setMounted] = useState<boolean>(false);

  const enableScroll = () => {
    document.body.style.cssText = '';
    document.body.style.overflow = 'unset';
  };

  const disableScroll = () => {
    document.body.style.overflow = 'hidden';
  };

  useEffect(() => {
    if (isShow) {
      disableScroll();
    } else {
      enableScroll();
    }
    return () => {
      enableScroll();
    };
  }, [isShow]);

  useEffect(() => {
    setMounted(true);
    if (document) {
      const dom = document.getElementById('root-modal');
      ref.current = dom;
    }
  }, []);

  if (ref.current && mounted) {
    return createPortal(
      <Container
        $isShow={isShow}
        style={{
          ...style,
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        {children}
      </Container>,
      ref.current
    );
  }
  return null;
};

const Container = styled.div<{ $isShow: boolean }>`
  /* Tailwind CSS utilities converted to CSS */
  position: fixed;
  inset: 0; /* top: 0, right: 0, bottom: 0, left: 0 */
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
  transition-property: opacity;
  transition-duration: 75ms;
  transition-timing-function: ease-out;

  display: ${(props) => (props.$isShow ? 'flex' : 'none')};

  overflow: hidden;
  touch-action: none;

  animation: showModal 0.2s ease-in-out;

  opacity: ${(props) => (props.$isShow ? 1 : 0)};

  z-index: ${(props) => (props.$isShow ? 200 : 50)};

  @keyframes showModal {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
